export const SET_NAME_FOR_ADDRESS = 'SET_NAME_FOR_ADDRESS';

let initialState = {};

function addressToNameReducer (state = initialState, action) {
  switch (action.type) {
    case SET_NAME_FOR_ADDRESS:
      let newState = {...state};
      newState[action.payload.address] = action.payload.name;
      return newState;
    default:
      return state;
  }
}

export default addressToNameReducer;


// WEBPACK FOOTER //
// ./src/storage/AddressToNameReducer.js